module.exports = __webpack_public_path__ + "static/media/promotional_modern.6dee9cde.png";